import React, { useEffect, useRef } from 'react';
import { Button } from './Button';
import { PlayIcon, Users, Brain, Target, Star, Heart, BookOpenIcon } from 'lucide-react';
export const Hero = () => {
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const parallaxFast = document.querySelector('.parallax-fast');
      if (parallaxFast) parallaxFast.setAttribute('style', `transform: translateY(${scrollY * 0.02}px)`);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <section className="w-full py-section-mobile md:py-section-desktop overflow-hidden relative bg-gradient-to-br from-white via-primary-50/30 to-blue-50/30" data-id="element-140">
      <style jsx data-id="element-141">{`
        @keyframes breathe {
          0%,
          100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.04);
          }
        }

        @keyframes pulse-glow {
          0%,
          100% {
            opacity: 0.4;
            transform: scale(1);
          }
          50% {
            opacity: 0.7;
            transform: scale(1.1);
          }
        }

        .hero-illustration-container {
          position: relative;
          transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .hero-illustration-container:hover {
          animation: breathe 2.5s ease-in-out infinite;
        }

        .hero-illustration-container::before {
          content: '';
          position: absolute;
          inset: -40px;
          background: radial-gradient(
            ellipse at center,
            rgba(251, 146, 60, 0.4) 0%,
            rgba(249, 115, 22, 0.3) 30%,
            rgba(234, 88, 12, 0.2) 50%,
            transparent 70%
          );
          opacity: 0;
          transition: opacity 0.6s ease-in-out;
          pointer-events: none;
          z-index: -1;
          filter: blur(30px);
        }

        .hero-illustration-container:hover::before {
          animation: pulse-glow 2.5s ease-in-out infinite;
        }

        .hero-illustration-container::after {
          content: '';
          position: absolute;
          inset: -20px;
          background: radial-gradient(
            circle,
            rgba(6, 182, 212, 0.15) 0%,
            transparent 60%
          );
          opacity: 0;
          transition: opacity 0.6s ease-in-out;
          pointer-events: none;
          z-index: -1;
          filter: blur(20px);
        }

        .hero-illustration-container:hover::after {
          animation: pulse-glow 2.5s ease-in-out infinite 0.3s;
        }
      `}</style>

      {/* Background Icons */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-142">
        {/* Icons with adjusted opacity */}
        <div className="absolute top-20 left-[10%] w-32 h-32 text-gray-300/10 transform -rotate-12" data-id="element-143">
          <BookOpenIcon strokeWidth={1} data-id="element-144" />
        </div>
        <div className="absolute top-40 right-[15%] w-40 h-40 text-gray-300/10 transform rotate-12" data-id="element-145">
          <Users strokeWidth={1} data-id="element-146" />
        </div>
        <div className="absolute bottom-40 left-[20%] w-36 h-36 text-gray-300/10 transform rotate-45" data-id="element-147">
          <Brain strokeWidth={1} data-id="element-148" />
        </div>
        <div className="absolute top-1/3 right-[25%] w-28 h-28 text-gray-300/10" data-id="element-149">
          <Target strokeWidth={1} data-id="element-150" />
        </div>
        <div className="absolute bottom-1/4 right-[10%] w-24 h-24 text-gray-300/10 transform -rotate-12" data-id="element-151">
          <Star strokeWidth={1} data-id="element-152" />
        </div>
        <div className="absolute top-2/3 left-[15%] w-32 h-32 text-gray-300/10" data-id="element-153">
          <Heart strokeWidth={1} data-id="element-154" />
        </div>
      </div>
      <div className="container mx-auto px-4 sm:px-6" data-id="element-155">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center" data-id="element-156">
          <div className="lg:col-span-7 relative" data-id="element-157">
            <div id="hero-logo" className="mb-8 lg:mb-12" data-id="element-158">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jP7ueorRtM9x7giMYpBsys/nisa-capriola-logotype.png" alt="Nisa" className="h-14 md:h-20 w-auto" data-id="element-159" />
            </div>
            <h1 className="font-serif font-medium md:text-display-desktop text-teal-950 mb-6 lg:mb-10 text-[36px]" data-id="element-160">
              Coaching simplified.
              <br data-id="element-161" />
              Impact multiplied.
            </h1>
            <div className="gradient-line w-16 md:w-24 mb-6 lg:mb-10" data-id="element-162"></div>
            <p className="text-gray-600 mb-8 max-w-2xl md:leading-normal text-[16px]" data-id="element-163">
              Nisa is a thoughtful companion for instructional coaches. Our
              ecosystem of connected tools understands your context, lightens
              your load, and helps you support teachers more meaningfully. Chat
              with Nisa anytime for all of your coaching touchpoints.
            </p>
            <div className="flex flex-col sm:flex-row gap-6" data-id="element-164">
              <a href="http://app.nisa.coach" data-id="element-165">
                <Button size="lg" data-id="element-166">Create a coach account</Button>
              </a>
            </div>
          </div>
          <div className="lg:col-span-5" data-id="element-167">
            <div className="relative h-full hero-illustration-container" data-id="element-168">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2Huxx8rff8YtszHy2fW7f1/Nisa_Duo.png" alt="Illustration of a coach and teacher having a conversation" className="w-full h-full object-contain" data-id="element-169" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};